import { render, staticRenderFns } from "./validation.vue?vue&type=template&id=c968411c&scoped=true"
import script from "./validation.vue?vue&type=script&lang=js"
export * from "./validation.vue?vue&type=script&lang=js"
import style0 from "./validation.vue?vue&type=style&index=0&id=c968411c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c968411c",
  null
  
)

export default component.exports